import { HubConnection } from '@microsoft/signalr';

export abstract class BaseHub {
  constructor(
    protected readonly hubConnection: HubConnection,
    protected readonly isBackendApiV2: boolean,
  ) {}

  abstract subscribe(topic: string, ...args: unknown[]): Promise<unknown>;
  abstract unsubscribe(topic: string): Promise<unknown>;
}
